module.exports = ".header-label {\n  font-weight: bold;\n  text-align: right;\n}"